// src/layout/AuthLayout.tsx

import React from 'react';
import { Outlet } from '@tanstack/react-router';
import { useSelector } from 'react-redux';
import { Container, GradientCardLayout, Loader } from 'shared-portal-component';

import Footer from '@/components/molecules/Footer/Footer';
import { selectIsSubmitting } from '@/store/selectors/auth';

const AuthLayout: React.FC = () => {
  const isSubmitting = useSelector(selectIsSubmitting);

  return (
    <GradientCardLayout gradientClass="gradient-bg" footer={<Footer />} logo="/Logo.svg" title="">
      {isSubmitting && (
        <div className="global-loader-overlay" role="alert" aria-busy="true" aria-live="polite">
          <Loader />
        </div>
      )}
      <Container fluid className="w-full">
        <Outlet />
      </Container>
    </GradientCardLayout>
  );
};

export default AuthLayout;
